<template>
  <div class="hello"></div>
</template>

<script>
import base64 from 'base-64';
import utf8 from 'utf8';

export default {
	name: 'DecryptHash',
	created: function() {
		// Decode base64:
		let formValues = null;
		let dataValid = true;
		let hashValue = this.$route.params.hash;
		if (hashValue && hashValue.length > 0) {
			formValues = JSON.parse(utf8.decode(base64.decode(hashValue)));
			if (!formValues.tickValue || formValues.tickValue < 0) {
				dataValid = false;
			}
			if (!formValues.frequency || formValues.frequency < 0) {
				dataValid = false;
			}
			if (!Number.isInteger(formValues.startHours) || formValues.startHours < 0 || formValues.startHours > 23) {
				dataValid = false;
			}
			if (!Number.isInteger(formValues.startMinutes) || formValues.startMinutes < 0 || formValues.startMinutes > 59) {
				dataValid = false;
			}
			if (!formValues.currency || formValues.currency.length <= 0) {
				dataValid = false;
			}
		} else {
			dataValid = false;
		}

		if (dataValid) {
			this.$emit('formValuesChanged', formValues);
		}
		this.$router.push({name: 'root'});
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>